import React, { Component } from 'react';
import EirNotification from '../eir-notification/EirNotification';
import FormattedPrice from '../formatted-price/FormattedPrice';
import EirDropdownInfo from '../dropdown-info/DropdownInfo';

import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardFooter,
  Modal,
  ModalBody
} from 'reactstrap';

import EirButton from '../eir-button/EirButton';
import TVChannelPopUp from '../tv-channel-popup/TVChannelPopup';
import EirLogin from '../eir-login/EirLogin';

class EirCard extends Component {

  priceTypes = {
    devicePrice: 'Phone price'
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopUp: false,
      displayModel: false,
    };

    this.toggle = this.toggle.bind(this);
    this.getLoginModal = this.getLoginModal.bind(this);
    //this.toggleModel = this.toggleModel.bind(this);
    this.splitUrl = window.location.href.split('/');
    this.userType = this.splitUrl[this.splitUrl.length - 2];

  }

  toggle() {
    this.setState(prevState => ({
      showPopUp: !prevState.showPopUp
    }));
  }

  getLoginModal() {
    this.setState(prevState => ({
      displayModel: !prevState.displayModel
    }));
  }

  //   toggleModel () {
  //     // this.setState({
  //     //   displayModel: false,
  //     // });
  // }

  createScriptInclude = (src) => {
    const script = document.createElement("script");
    script.src = src;
  }

  render() {
    // console.log('this.props',this.props);
    //var priceIndex = 0;
    //if (this.props.prequalUrl) {
    //  var ftthFee = parseFloat(this.props.ftthFee);
    //  console.log("FEES");
    //  console.log(this.props.this)
    //  if ()
    //  priceIndex = 1;
    //}
    let priceIndex = 0;
    if (this.props.priceIndex) {
      priceIndex = this.props.priceIndex
    }
    var price = String(this.props.price[priceIndex].priceFormatted);
    var prices = price.split('.');
    if (prices[0].charAt(0) === '0') {
      prices[0] = prices[0].substr(1);
    }

    let ulHeight = 0;
    ulHeight = ((this.props.maxNumFeatures * 32) + 32) + "px"

    var numberOfFeatures = this.props.features.length;

    return (

      <Card id={(this.props.id)} className={(this.props.hero ? 'hero' : '') + ' eir-card '
        + (this.props.prequalUrl ? 'eir-card-prequal' : '')}>

        <CardBody
          onClick={this.handleClick}
          className={'eir-card-body d-flex flex-column' + (this.props.prequalUrl ? ' flex-grow-0' : '')}
        >


          {this.renderSash()}

          {this.props.roundel && (
            <EirNotification modalTitle={this.props.roundel.title} modalText={this.props.roundel.shortDescription} clickable={true} text={this.props.roundel.title} card={true} />
          )}

          <CardTitle className="eir-card-title text-base-gray">
            {this.props.name ? this.props.name : <br />}
          </CardTitle>

          <div className="price-wrapper text-center">
            <h2 className="display-1 eir-card-price">
              &euro;{prices[0]}
              <span>.{prices[1]}</span>
            </h2>
          </div>
          {this.renderCardSubtitles()}
          {this.props.mainFeatures.map((mainFeature, index) => {
            return (
              <div key={'eir-card-mainfeature' + index} className="eir-card-mainfeature">{mainFeature}</div>
            );
          })}
          {this.state.showPopUp && (
            < TVChannelPopUp
              show={true}
              toggle={this.toggle}
              title="eir TV Standard channels"
              tvLogos={this.props.tvLogos}
            />
          )}

          <div className={this.props.prequalUrl ? "more-details-feature-wrapper" : "feature-wrapper"}>
            <ul style={this.props.prequalUrl && { height: ulHeight }}>
              {/*} <ul> {*/}
              {this.props.features.map((feature, index) => {
                // See of the last feature should pop up the channel list
                if (index === (numberOfFeatures - 1) && (this.props.channelPopUp)) {
                  return (
                    <li onClick={this.toggle} key={'eircard-feature' + index} className="card-text eir-card-feature feature-link"><u>{feature}</u></li>
                  );
                }
                return (
                  <li key={'eircard-feature' + index} className="card-text eir-card-feature">{feature}</li>
                );
              })}
            </ul>
          </div>
          {this.props.footerInfos.map((footerInfo, index) => {
            return (
              <li dangerouslySetInnerHTML={{ __html: footerInfo }} key={'eircard-feature' + index} className="card-text eir-card-feature-with-a-tag"></li>
            );
          })}
        </CardBody>
        <CardFooter className="eir-card-footer">
          {this.props.oneOffCosts && this.props.oneOffCosts.map((oneOffCost, index) => {
            return (
              <FormattedPrice key={'eir-card-fixedPrice' + index} className='mb-3' price={oneOffCost.price} label={this.priceTypes[oneOffCost.type]} />
            );
          })}

          {this.props.moreDetails && (
            <div className="pt-2 pb-2 text-center">
              <EirDropdownInfo
                titleOpen="Show less"
                titleClosed="More details"
                dropDownInfo={this.props.dropDownInfo}
                maxDropDownLines={this.props.maxDropDownLines}
              />
            </div>
          )}

          {this.renderButton()}

        </CardFooter>
        <div className="">
          <Modal className="LoginModal modalDialog" centered={true} isOpen={this.state.displayModel} toggle={this.getLoginModal} >
            <ModalBody className={"modalContent "}>

              <img onClick={this.getLoginModal} src={'/.galleries/eir/icons/plus-circle.png'} alt="Close" className="phonedetails-close-icon" />

              <EirLogin></EirLogin>
            </ModalBody>
          </Modal>
        </div>
      </Card>

      /*  */

    );
  }


  renderSash = () => {
    let validSash = false
    let wrapper;
    let sash;
    let sashString;
    //EIR-1919 display promo string for all bundle card.
    if (this.props.promo) {
      wrapper = 'promo-sash-wrapper'
      sash = 'promo-sash'
      sashString = this.props.promoString
      validSash = true
    } else if (this.props.sash) {
      wrapper = 'sash-wrapper'
      sash = 'sash'
      sashString = this.props.sash
      validSash = true
    }
    if (validSash) {
      return (
        <div className={wrapper}>
          <div className={sash}>{sashString}</div>
        </div>
      )
    }
  };
  callPrequal = (e) => {

    // e.preventDefault();
    var $this = $(this);
    // console.log("eeeeeeeeeEE", e);



    // $("head").append('<script src="/opencms/export/system/modules/net.eir.opencms/resources/js/external/modules/m02-prequal/m02-prequal-layout.js"></script>');
    // $("head").append('<script src="/opencms/export/system/modules/net.eir.opencms/resources/js/external/modules/m02-prequal/m02-prequal.js"></script>');


    document.cookie = "eir_clicked_context=" + e.target.getAttribute('data-context') + ";expires: 1000; path=/";
    document.cookie = "eir_clicked_bundle_code=" + e.target.getAttribute('data-bundle-code') + ";expires: 1000; path=/";
    document.cookie = "eir_clicked_context_id=" + e.target.getAttribute('data-bundle-code') + ";expires: 1000; path=/";

    if (e.target.getAttribute('data-context') != 'false') {
      // console.log('before creating hidden .prequal-in-modal');
      $('.prequal__form.active-form').append('<input type="hidden" class="prequal-in-modal" value=' + e.target.getAttribute("data-context") + '>');
      //the below localStorage is accessed in opencmx -- home/html-blocks/prequal/prequal.html
      localStorage.setItem("ls-eir_clicked_context", e.target.getAttribute('data-context'));
      localStorage.setItem("ls-eir_bundle_card_clicked", "cardselected");
      this.clearProspect();
      if (navigator.vendor.toLowerCase().indexOf("apple") == 0 && this.props.ctaValue.endsWith("_FL")) {
        localStorage.setItem("ls-eir_bundle_name", e.target.getAttribute('data-bundle-name'));
      }
    }

    if (this.userType == 'existing') {
      this.getLoginModal();
    }


  }
  clearProspect = () => {
    localStorage.removeItem('ACQ_PROSPECTUUID');
    localStorage.removeItem('CO_REF');
    localStorage.removeItem('CS_REF');
    localStorage.removeItem('ACQ_PORTIN');
    localStorage.removeItem('prospectUuid');
    localStorage.removeItem('offerId');
    localStorage.removeItem('plan-name');
    localStorage.removeItem('handset-name');
    localStorage.removeItem('prepayHandsetId');
    localStorage.removeItem('IONOrderReference');
    localStorage.removeItem('planToggle');
  }

  renderButton = () => {
        let setContext;
    // PREQUAL ONL  
    

    if (this.props.prequalUrl) {
            setContext = this.props.prequalUrl.split("/")[1];
      if (navigator.vendor.toLowerCase().indexOf("apple") == 0 && this.props.ctaValue.endsWith("_FL")) {
        this.props.prequalUrl = "/forlife/bundles/eoi";
      }
      if(this.props.useChat ==="true" ){
                return(
          <div className="eir-card-useChat-text" >
            <p onClick={() => document.querySelector('#chat-sticky').click()}>
              {
                this.props.ctaText
              }
            </p>
          </div>
        )



      }
      else{
        return (
          <EirButton className="px-3 js-prequal-modal-btn color-dark-purple"
            color="primary"
            outline={true}
            type="button"
            text={this.props.ctaText}
            link={(this.userType == 'existing') ? () => { this.getLoginModal } : this.props.prequalUrl}
            id={this.props.ctaValue}//{this.props.id}
            datacontext={setContext}
            databundlecode={this.props.ctaValue}
            onClick={this.callPrequal.bind(this)}
            databundleTitle={this.props.name}
          />
        )

      }
      
    } else {
            if(this.props.useChat==="true"){
                return(
          <div className="eir-card-useChat-text">
            <p onClick={() => document.querySelector('#chat-sticky').click()} >
              {
                this.props.ctaText
              }
            </p>
          </div>
        )



      }
      else{
                return (
          <EirButton
            color="primary"
            outline={true}
            type="button"
            text={this.props.ctaText}
            name={this.props.ctaName}
            value={this.props.ctaValue}
            className="eir-text-secondary color-dark-purple"
            onClick={() => {this.clearProspect()}}
          />
        )
        

      }
      // Add to cart
      
    }

  };

  renderCardSubtitles = () => {
    //console.log("props >>> ", this.props);
    if (!this.props.hideContractDuration) {
      if (this.props.subtitles && this.props.subtitles.length > 0) {
        return (
          <div className="eir-card-subtitle">
            {this.props.subtitles.map(function (subtitle, index) {
              return <CardSubtitle className="eir-card-subheadline" key={index}>{subtitle ? subtitle : <br />}</CardSubtitle>;
            })
            }
          </div>
        )
      } else {
        return (<div><CardSubtitle className="eir-card-subheadline" index={0}><br /></CardSubtitle></div>)
      }
    }
  };
}
export default EirCard;
